import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
import { Colors, Fonts, Metrics } from '../../Themes'

const Container = styled.div`
  .textAreaTitle {
    margin-bottom: ${Metrics.margins.small};
    ${Fonts.style.Label};
    color: ${Colors.black};
  }

  .error {
    ${Fonts.style.Input};
    color: ${Colors.red};
  }

  textarea {
    width: 100%;
    padding: ${Metrics.margins.tiny};
    min-height: 100px;
    border: ${Metrics.borders.default};
    border-radius: ${Metrics.borders.defaultRadius};
    outline: none;
    ${Fonts.style.Input};
    color: ${Colors.black};
    resize: none;
    &::-webkit-input-placeholder {
      height: ${Metrics.components.inputFormHeight};
      color: ${Colors.darkGrey};
    }
    &::-moz-placeholder {
      /* Firefox 19+ */
      height: ${Metrics.components.inputFormHeight};
      color: ${Colors.darkGrey};
    }
    &:-ms-input-placeholder {
      /* IE 10+ */
      height: ${Metrics.components.inputFormHeight};
      color: ${Colors.darkGrey};
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      height: ${Metrics.components.inputFormHeight};
      color: ${Colors.darkGrey};
    }
  }
`

class Textarea extends Component {
  shouldComponentUpdate (nextProps) {
    const { value, error } = this.props
    if (value !== nextProps.value || error !== nextProps.error) {
      return true
    }
    return false
  }

  render () {
    const {
      title,
      placeholder,
      required,
      value,
      handleChange,
      error,
      handleBlur,
      name
    } = this.props

    const inputTitle = title ? (
      <div className='textAreaTitle'>
        {title}
        {required ? '*' : ''}
      </div>
    ) : null

    return (
      <Container className='textAreaForm' tabIndex='-1' onBlur={handleBlur}>
        {inputTitle}
        <textarea
          required={required}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          name={name}
        />
        {error && <div className='error'>{error}</div>}
      </Container>
    )
  }
}

Textarea.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  name: PropTypes.string
}

Textarea.defaultProps = {
  value: ''
}

export default Textarea



// WEBPACK FOOTER //
// ./src/components/Textarea/index.js